export default "__VITE_ASSET__DmUeZfb2__"